module.exports = "/_next/static/images/63935b3bf736cd08e6470d0752c17931-man-with-cellphone-lg@1x.jpg";